function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  id: "icon",
  transform: "translate(-1.9444444444444287 -1.9444444444444287) scale(3.89 3.89)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 80.162 75.737 C 86.514 69.033 90 60.295 90 51.021 c 0 -15.995 -10.687 -30.165 -26.021 -34.569 C 57.38 8.264 47.278 3.011 35.967 3.011 C 16.135 3.011 0 19.146 0 38.978 c 0 9.273 3.486 18.01 9.837 24.716 l -9.544 9.544 c -0.286 0.286 -0.372 0.716 -0.217 1.09 S 0.596 74.945 1 74.945 h 26.187 c 6.828 7.655 16.581 12.044 26.845 12.044 H 89 c 0.404 0 0.77 -0.243 0.924 -0.617 c 0.155 -0.374 0.069 -0.804 -0.217 -1.09 L 80.162 75.737 z M 11.949 64.411 c 0.391 -0.391 0.391 -1.023 0 -1.414 C 5.533 56.581 2 48.051 2 38.978 C 2 20.249 17.238 5.011 35.967 5.011 c 18.73 0 33.967 15.238 33.967 33.967 c 0 18.73 -15.237 33.967 -33.967 33.967 H 3.414 L 11.949 64.411 z M 54.032 84.989 c -9.082 0 -17.74 -3.639 -24.1 -10.044 h 6.035 c 19.833 0 35.967 -16.135 35.967 -35.967 c 0 -7.291 -2.187 -14.077 -5.929 -19.75 C 79.092 24.158 88 36.829 88 51.021 c 0 9.073 -3.533 17.604 -9.949 24.019 c -0.188 0.188 -0.293 0.441 -0.293 0.707 s 0.105 0.52 0.293 0.707 l 8.535 8.535 H 54.032 z",
  transform: " matrix(1 0 0 1 0 0) ",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 52.188 23.99 H 19.741 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 32.448 c 0.553 0 1 0.448 1 1 S 52.741 23.99 52.188 23.99 z",
  transform: " matrix(1 0 0 1 0 0) ",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 52.188 33.99 H 19.741 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 32.448 c 0.553 0 1 0.448 1 1 S 52.741 33.99 52.188 33.99 z",
  transform: " matrix(1 0 0 1 0 0) ",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 52.188 43.99 H 19.741 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 32.448 c 0.553 0 1 0.448 1 1 S 52.741 43.99 52.188 43.99 z",
  transform: " matrix(1 0 0 1 0 0) ",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 36.254 53.99 H 19.741 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 16.514 c 0.552 0 1 0.447 1 1 S 36.807 53.99 36.254 53.99 z",
  transform: " matrix(1 0 0 1 0 0) ",
  strokeLinecap: "round"
}));

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.8ead969a.svg";
export { ForwardRef as ReactComponent };